module.exports = __webpack_public_path__ + "static/media/mongoose.5566eb27.svg";